import {
    CONFIRMED_GET_AMENITY
} from '../actions/Amenity/AmenityTypes';
const initialState = {
    amenity: [],
    loading: false,
};

function AmenityReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'AMENITY_LOADING':
            return {
                ...state,
                loading: true,
            };
        case CONFIRMED_GET_AMENITY:
            return {
                ...state,
                amenity: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {AmenityReducer};